import PropTypes from 'prop-types'
import { memo, useMemo, useRef } from 'react'
import useIntersectionObserver from 'components/core/Intersection/hooks/useIntersectionObserver'
import useDelayedActiveState from 'lib/react/hooks/useDelayedActiveState'
import { isTouch } from 'lib/support'
import classNames from 'lib/util/classNames'
import styles from './BorderHighlight.module.scss'

/**
 * The `BorderHighlight`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function BorderHighlight (props) {
  const { animateOnMobile, className, isActive } = props
  const ref = useRef()
  const isVisible = useDelayedActiveState(isActive, 0, 0.5)
  const { isIntersecting } = useIntersectionObserver(ref)
  const classNameOutput = useMemo(
    () =>
      classNames([
        className,
        styles.highlight,
        isActive && styles.active,
        isVisible &&
          isIntersecting &&
          (!isTouch || animateOnMobile) &&
          styles.animate
      ]),
    [className, isActive, isVisible, isIntersecting, animateOnMobile]
  )

  return (
    <div ref={ref} className={classNameOutput}>
      <div>
        <div />
      </div>
      <div>
        <div />
      </div>
    </div>
  )
}

/** @type {object} */
BorderHighlight.propTypes = {
  className: PropTypes.string,
  isActive: PropTypes.bool,
  animateOnMobile: PropTypes.bool
}

/** @type {object} */
BorderHighlight.defaultProps = {
  className: '',
  isActive: false,
  animateOnMobile: false
}

// Memoize
export default memo(BorderHighlight)
